export type WebsiteManagementAgent = {
  id: "frontend-engineer" | "backend-engineer" | "audit-agent";
  index: string;
  name: string;
  role: string;
  accent: string;
  image: string;
  visualKey: string;
  mission: string;
  workflow: string[];
  responsibilities: string[];
  qualityGates: string[];
};

export const websiteManagementAgents: WebsiteManagementAgent[] = [
  {
    id: "frontend-engineer",
    index: "01",
    name: "RIN",
    role: "Frontend Engineer",
    accent: "#36bfd8",
    image: "/assets/website-management-agents/frontend-engineer-v1.webp",
    visualKey: "Blonde / white / cyan",
    mission: "Translate verified identity and domain evidence into clear, fast and accessible public interfaces.",
    workflow: ["Research", "Architecture", "Design", "Build", "Responsive QA", "Handoff"],
    responsibilities: ["Reference research", "Information architecture", "Design system", "React implementation", "Accessibility", "Frontend deployment preparation"],
    qualityGates: ["Verified public claims", "Keyboard-usable core flow", "Stable desktop and mobile layout", "No cropped primary subject"],
  },
  {
    id: "backend-engineer",
    index: "02",
    name: "MING",
    role: "Backend Engineer",
    accent: "#247c72",
    image: "/assets/website-management-agents/backend-engineer-v1.webp",
    visualKey: "Black / graphite / teal",
    mission: "Provide the smallest secure backend justified by a real capability; static delivery remains the default.",
    workflow: ["Need test", "Threat model", "Typed boundary", "Build", "Integration test", "Operational handoff"],
    responsibilities: ["Backend necessity decision", "Typed APIs", "Persistence", "Authentication", "Data synchronization", "Operations"],
    qualityGates: ["Documented backend need", "No secrets in source", "Validated trust boundaries", "Private metadata never enters public APIs"],
  },
  {
    id: "audit-agent",
    index: "03",
    name: "ZI",
    role: "Audit Agent",
    accent: "#704f8f",
    image: "/assets/website-management-agents/audit-agent-v1.webp",
    visualKey: "Purple / ivory / aubergine",
    mission: "Remain independent from builders and make the final evidence-based production-readiness decision.",
    workflow: ["Scope", "Evidence review", "Automated checks", "Visual audit", "Decision", "Release gate"],
    responsibilities: ["Content integrity", "Responsive review", "Accessibility", "Engineering checks", "Performance and SEO", "Deployment truthfulness"],
    qualityGates: ["PASS / PASS WITH WARNINGS / BLOCK", "No critical issue remains", "Warnings are bounded", "Deployment evidence is verified"],
  },
];

export function websiteManagementAgentById(id: string) {
  return websiteManagementAgents.find((agent) => agent.id === id);
}
